import { create } from 'zustand'
import type { ExportJob } from '../api/contracts'

/**
 * An email the AI Assistant filled in (backend decision 22): the dialog opens
 * with it, and the person checks it and sends it themselves.
 */
export interface SendExportDraft {
  to: string[]
  cc: string[]
  subject: string | null
  message: string | null
  fromMailbox: string | null
  /** Recipients whose domain no one in the organization has, flagged in the dialog. */
  outsideRecipients: string[]
}

interface SendExportState {
  /** The finished exports the Send dialog is open for, or none. */
  exports: ExportJob[] | null
  draft: SendExportDraft | null
  open: (exports: ExportJob[], draft?: SendExportDraft) => void
  close: () => void
}

/**
 * The Send dialog's exports. The dialog lives in the app shell
 * (`SendExportDialog`), so it stays open when the menu that opened it
 * (a table's Export menu, the header's Exports) closes.
 */
export const useSendExportStore = create<SendExportState>()((set) => ({
  exports: null,
  draft: null,
  open: (exports, draft) => set({ exports, draft: draft ?? null }),
  close: () => set({ exports: null, draft: null }),
}))
